<template>
<div class="container">

    <div class="e2018_details">

        <div class="title">

            <h2>
                <span class="year">2020</span> <span class="first">E</span>lection: <span class="first" v-html="page_name.charAt(0)"></span>{{ page_name.substring(1) }}
            </h2>
            <h3 v-if="page_sub" v-html="page_sub"></h3>

        </div>

        <ul class="top_nav">
            <li v-for="result in top_results">
                <a class="top" :href="E2020_PUB_PATH+'/'+result.basename+'/'">2020 Election {{ result.name }}</a>
                <a class="bottom" :href="E2020_PUB_PATH+'/'+result.basename+'/'">Live Results</a>
            </li>
        </ul>

        <div class="top_results">

            <div class="result" v-for="(result, result_index) in top_results">

                <div class="title">2020 {{ result.name }} <!--Results--> </div>
            
                <div class="score" v-if="result_index == 0" >
                    
                    <div v-if="loading && page_basename == 'president' " class="e2018_spinner">
                        <div>
                            <div></div>
                        </div>
                    </div>

                    <div v-show="first_load_done" class="party dem" >
                        <div class="title">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'">Biden/Harris</a>
                        </div>
                        <div class="score">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'" v-html="electoral_summary.Biden"></a>
                        </div>
                    </div>
                    <div v-show="first_load_done" class="party gop" >
                        <div class="title">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'">Trump/Pence</a>
                        </div>
                        <div class="score">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'" v-html="electoral_summary.Trump"></a>
                        </div>
                    </div>
                </div>

                <div class="score" v-if="result_index > 0" >
                    
                    <div v-if="loading" class="e2018_spinner">
                        <div>
                            <div></div>
                        </div>
                    </div>

                    <div v-show="first_load_done" class="party dem" >
                        <div class="title">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'">Democrats</a>
                        </div>
                        <div class="score">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'" v-html="won_seats[result.basename].dem + (result.basename=='senate' ? '*' : '') + net_display(net_seats[result.basename].dem)"></a>
                        </div>
                    </div>
                    <div v-show="first_load_done" class="party gop" >
                        <div class="title">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'">Republicans</a>
                        </div>
                        <div class="score">
                            <a :href="E2020_PUB_PATH+'/'+result.basename+'/'" v-html="won_seats[result.basename].gop + '' + net_display(net_seats[result.basename].gop)"></a>
                        </div>
                    </div>
                </div>

                <div class="states">
                    <select v-model="dropdown_link[result.basename]" @change="go_to_dropdown_link(result.basename)" v-if="typeof state_links[result.basename] !== 'undefined'" >
                        <option :selected="true" value="0"> <!--Individual--> Race Results - {{ result.name }}</option>
                        <option v-for="link in state_links[result.basename]" :value="link.link" v-html="link.name"></option>
                    </select>
                </div>

            </div>

        </div>

        <div class="house_pages_nav" v-if="featured_race_type_to_race_type(page_basename) == 'house'">
            <a :class="{'active' : page_basename == 'house' }" href="'+E2020_PUB_PATH+'/house/">All House Results</a> &middot; 
            <a :class="{'active' : page_basename == 'house_top_50' }" href="'+E2020_PUB_PATH+'/house_top_50/">Top Races</a> &middot; 
            <a :class="{'active' : page_basename == 'house_northeast' }" href="'+E2020_PUB_PATH+'/house_northeast/">Northeast</a> &middot; 
            <a :class="{'active' : page_basename == 'house_midwest' }" href="'+E2020_PUB_PATH+'/house_midwest/">Midwest</a> &middot; 
            <a :class="{'active' : page_basename == 'house_south' }" href="'+E2020_PUB_PATH+'/house_south/">South</a> &middot; 
            <a :class="{'active' : page_basename == 'house_west' }" href="'+E2020_PUB_PATH+'/house_west/">West</a>
        </div>

        <div class="e2018_stars" v-else>****************</div>

        <div class="results_block">

            <div v-if="loading" class="e2018_spinner">
                <div>
                    <div></div>
                </div>
            </div>

            <div class="title">
                <div class="text">&middot; <a :href="E2020_PUB_PATH+'/'+page_basename+'/'" v-html="page_name"></a> &middot;</div>
                <div class="refresh" @click="fetch_data">Refresh</div>
            </div>

            <div v-if="first_load_done && page_basename == 'president' " class="overview">
                <span class="dem">Biden/Harris <a class="score" :href="E2020_PUB_PATH+'/'+page_basename+'/'" v-html="vote_percent_display_pres('Biden') + ' (' + electoral_summary.Biden + ')      ' "></a></span>
                <span class="gop">Trump/Pence <a class="score" :href="E2020_PUB_PATH+'/'+page_basename+'/'" v-html="vote_percent_display_pres('Trump')+ ' (' + electoral_summary.Trump + ')' "></a></span>
            </div>
            <div v-if="first_load_done && page_basename != 'president' " class="overview">
                <span class="dem">Democrats <a class="score" :href="E2020_PUB_PATH+'/'+featured_race_type_to_race_type(page_basename)+'/'" v-html="won_seats[featured_race_type_to_race_type(page_basename)]['dem'] + (page_basename=='senate' ? '*' : ' ') + net_display(net_seats[featured_race_type_to_race_type(page_basename)]['dem'])"></a></span>
                <span class="gop">Republicans <a class="score" :href="E2020_PUB_PATH+'/'+featured_race_type_to_race_type(page_basename)+'/'" v-html="won_seats[featured_race_type_to_race_type(page_basename)]['gop'] + ' ' + net_display(net_seats[featured_race_type_to_race_type(page_basename)]['gop'])"></a></span>
            </div>

            <div class="map" v-if="is_main_type(page_basename)">
                <div v-if="loading" class="e2018_spinner"><div><div></div></div></div>
                <transition name="fade"><img class="map_image" :key="img_map" :src="img_map" :alt="page_name+' Live Results 2018'" /></transition>
            </div>

            <table v-if="first_load_done" class="races">
                <tbody>
                    <tr>
                        <th></th>
                        <th>Democrat</th>
                        <th>Republican</th>
                        <th></th>
                        <th></th>
                        <th v-if="any_column_candidates(races[page_basename], 1)"></th>
                        <th v-if="any_column_candidates(races[page_basename], 2)"></th>
                        <th v-if="any_column_candidates(races[page_basename], 3)"></th>
                    </tr>

                    <template v-for="(race, index) in races[page_basename]">

                        <tr v-if="page_basename != 'house_top_50' && featured_race_type_to_race_type(page_basename) == 'house' && (index == 0 || races[page_basename][index-1]['stateName'] !== race['stateName'])">
                        <td class="state" :colspan="5+(any_column_candidates(races[page_basename], 1) ? 1 : 0)+(any_column_candidates(races[page_basename], 2) ? 1 : 0)+(any_column_candidates(races[page_basename], 3) ? 1 : 0)" v-html="race['stateName']"></td>
                        </tr>

                        <tr :class="[{'race' : true}, winner_party(race), {'pickup' : winner_is_pickup(race)}, {'winner' : has_winner(race) || ['Georgia Special', 'Georgia'].indexOf(state_name_display(race.stateName, race.seatName, page_basename)) > -1},{'is_ga_special': ['Georgia Special', 'Georgia'].indexOf(state_name_display(race.stateName, race.seatName, page_basename)) > -1}]">
                        
                            <td class="name">
                                <div>
                                    <a :href="race_detail_link(race, page_basename)" v-html="state_name_display(race.stateName, race.seatName, page_basename)"></a>
                                </div>
                            </td>
                        
                            <td v-for="candidate in candidates_with_party(race.reportingUnit.candidates, 'Dem', 1)" class="candidate">
                                <span v-html="candidate.last"></span> 
                                <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                            </td>
                            <td v-if="candidates_with_party(race.reportingUnit.candidates, 'Dem', 1).length == 0"></td>
                        
                            <td v-for="candidate in candidates_with_party(race.reportingUnit.candidates, 'GOP', 1)" class="candidate">
                                <span v-html="candidate.last"></span> 
                                <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                            </td>
                            <td v-if="candidates_with_party(race.reportingUnit.candidates, 'GOP', 1).length == 0"></td>
                        
                            <td v-for="candidate in column_candidates(race.reportingUnit.candidates, 1)" class="candidate" :style="state_name_display(race.stateName, race.seatName, page_basename) == 'Georgia Special' ? 'font-weight:normal;' : ''">
                                <span v-html="candidate.last+' '+party_display(candidate)"></span> 
                                <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                            </td>
                            <td v-if="column_candidates(race.reportingUnit.candidates, 1).length == 0 && any_column_candidates(races[page_basename], 1)"></td>
                        
                            <td v-for="candidate in column_candidates(race.reportingUnit.candidates, 2)" class="candidate" v-if="state_name_display(race.stateName, race.seatName, page_basename) != 'Georgia Special'">
                                <span v-html="candidate.last+' '+party_display(candidate)"></span> 
                                <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                            </td>
                            <td v-if="( column_candidates(race.reportingUnit.candidates, 2).length == 0 && any_column_candidates(races[page_basename], 2) ) || state_name_display(race.stateName, race.seatName, page_basename) == 'Georgia Special'"></td>
                        
                            <td v-for="candidate in column_candidates(race.reportingUnit.candidates, 3)" class="candidate" v-if="state_name_display(race.stateName, race.seatName, page_basename) != 'Georgia Special'">
                                <span v-html="candidate.last+' '+party_display(candidate)"></span> 
                                <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                            </td>
                            <td v-if="( column_candidates(race.reportingUnit.candidates, 3).length == 0 && any_column_candidates(races[page_basename], 3) ) || state_name_display(race.stateName, race.seatName, page_basename) == 'Georgia Special'"></td>

                            <td class="percent_in">
                                <div v-html="display_precincts_perc(race)"></div>
                            </td>
                        
                            <td class="hold">
                                <div v-html="winner_hold_pickup_text(race)"></div>
                            </td>

                        </tr>

                    </template>
                </tbody>
            </table>

        </div>
        
        <!-- Bottom Location of Map -->

    </div>

</div>
</template>

<script>

import {rcp_refresh_interval, E2020_PUB_PATH} from './ElectionCommonVars.js';
import ElectionNightMixin from './ElectionNightMixin.js';

export default {
    name: 'rc-widget-live-results-body',
    mixins: [
        ElectionNightMixin,
    ],
    props: [
        'page_basename',
        'page_name',
        'page_sub'
    ],
    data : function() {
        return {
            "loading_interval" : 0,
            "loading" : true,
            "first_load_done" : false,
            "current_page" : "senate",
            "img_map" : "",
            "president_summary" : {},
            "electoral_summary" : {
                "Biden" : 0,
                "Trump" : 0,
            },
            "state_links": [],
            "races" : {
                "governor" : [],
                "house" : [],
                "senate" : [],
                "house_top_50" : [],
                "house_northeast" : [],
                "house_midwest" : [],
                "house_south" : [],
                "house_west" : [],
                "president" : []
            },
            "dropdown_link" : {
                "governor" : "0",
                "house" : "0",
                "senate" : "0",
                "president" : "0"
            },
            "candidate_vote_counts":{},
            "top_results": [
                {
                    "name" : "President",
                    "basename" : "president"
                },
                {
                    "name" : "Senate",
                    "basename" : "senate"
                },
                {
                    "name" : "House",
                    "basename" : "house"
                },
                {
                    "name" : "Governors",
                    "basename" : "governor"
                } 
            ],
            "won_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "net_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            }
        };
    },
    created : function() {

        this.get_data_for_page();

        // Start refresh cron
        this.loading_interval = setInterval(() => {
            this.fetch_data();
        }, rcp_refresh_interval * 1000);
    },
    methods: {

        is_main_type : function(type) {
            for(let i = 0; i < this.top_results.length; i++) {
                if(this.top_results[i]['basename'] == type) {
                    return true;
                }
            }

            return false;
        },

        fetch_data : function() {

            if(!this.loading) {
                this.get_data_for_page();
            }
        },

        get_data_for_page : function() {

            this.loading = true;
            axios.get(E2020_PUB_PATH+'/homepage.json?cache_bust='+this.rcp_cache_bust())
            .then((response) => {

                this.president_summary = response.data.president_summary;
                this.electoral_summary = response.data.electoral_summary;

                //Calculate vote count percentages and assign to object
                this.calculate_candites_votes();

            });
            // Retrieve live results data
            //axios.get('/elections/live_results/2018/'+this.page_basename+'.json?cache_bust='+rcp_cache_bust())
            axios.get(E2020_PUB_PATH+'/'+this.page_basename+'.json?cache_bust='+this.rcp_cache_bust())
            .then((response) => {

                this.won_seats = response.data.won_seats;
                this.net_seats = response.data.net_seats;
                this.state_links = response.data.state_links;

                this.races[this.page_basename] = this.races_with_vote_totals(response.data.races);

                // Refresh images
                // Do smart loading
                var img = new Image();
                var vue_this = this;
                var src = E2020_PUB_PATH+"/live_map_"+this.page_basename+".png?cache_bust="+this.rcp_cache_bust();
                var callback_apply = function(callback, vue_this, src) {
                    callback(vue_this, src);
                }
                img.onload = callback_apply(function(vue_this, src) {
                    vue_this.img_map = src;
                    vue_this.loading = false;
                }, vue_this, src);

                img.src = src;

                this.first_load_done = true;

            });
        },

        go_to_dropdown_link : function(bn) {

            if(this.dropdown_link[bn] != "0") {
                window.location.href = this.dropdown_link[bn];
            }
        },

        vote_percent_display_pres : function(cand){
            return this.candidate_vote_counts[cand] + '%';
        },

        calculate_candites_votes : function(){

            var total_votes = 0;
            for(let p=0; p < this.president_summary.candidates.length; p++){
                var can = this.president_summary.candidates[p];
                total_votes += parseInt(can.voteCount);
            }
            
            for(let p=0; p < this.president_summary.candidates.length; p++){
                var can = this.president_summary.candidates[p];
                
                var name = can.last;
                var can_vote_count = parseInt(can.voteCount);
                
                var percent = (can_vote_count / total_votes) * 100;

                if(total_votes == 0 || total_votes == 'undefined'){
                    this.candidate_vote_counts[name] = 0;
                }else{
                    this.candidate_vote_counts[name] = percent.toFixed(1);
                }
                
            }

        },

    },
}
</script>

<style lang="scss">

</style>